import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import {
  StockPartReqTableLineType,
  StockPartRequestLineActionType,
} from '../../stock-part-requests/types/stockPartRequestTypes';
import { DictionaryItem, NumberFunctionType } from '../../../core/types/coreTypes';
import TdNew from '../../../core/components/table-components/table-new/TdNew';
import Dropdown from '../../../core/components/dropdown/Dropdown';
import Tr from '../../../core/components/table-components/Tr';
import Checkbox from '../../../core/components/checkbox/Checkbox';

type StockPartRequestChildLineProps = {
  childLine: Omit<StockPartReqTableLineType, 'childLines'>,
  hiddenKeys: string[],
  nowrapKeys: string[],
  renderCellValue: (key: string, value: unknown, unitOfMeasure: number) => React.ReactNode | string | number,
  actionsRender: (status: string, sourceId: number) => StockPartRequestLineActionType[],
  deletedStatus?: DictionaryItem,
  archivedStatus?: DictionaryItem,
  allowedToManage?: boolean,
  isCheckboxRequired?: boolean,
  checked?: boolean,
  checkRowHandle?: NumberFunctionType,
}

const StockPartRequestChildLine: React.FC<StockPartRequestChildLineProps> = ({
  childLine,
  hiddenKeys,
  nowrapKeys,
  renderCellValue,
  actionsRender,
  deletedStatus,
  archivedStatus,
  allowedToManage,
  isCheckboxRequired,
  checked,
  checkRowHandle,
}) => {
  const disabledActions = !allowedToManage || childLine.status.toLowerCase() === archivedStatus?.label?.toLowerCase();
  return (
    <Tr
      className={classNames({ 'suitableLine': childLine.status.toLowerCase() === deletedStatus?.label?.toLowerCase() })}
    >
      {isCheckboxRequired && <TdNew>
        <Checkbox
          checked={checked}
          onChange={() => {
            if (checkRowHandle) {
              checkRowHandle(childLine.id);
            }
          }}
          disabled={!childLine.canPurchaseOrderBeGenerated}
          table
        />
      </TdNew>}
      {Object.entries(childLine).map(([key, value]) => {
        if (hiddenKeys.includes(key)) return null;
        return <TdNew key={key} className={nowrapKeys.includes(key) ? 'nowrap' : ''}>
          {renderCellValue(key, value, childLine.unitOfMeasure)}
        </TdNew>;
      })}
      <TdNew action>
        <Dropdown
          icon={<FontAwesomeIcon icon={faEllipsisVertical} />}
          menuItems={actionsRender(childLine.status, childLine.id)}
          disabled={disabledActions}
        />
      </TdNew>
    </Tr>
  );
};

export default StockPartRequestChildLine;
